import {Button} from "@chakra-ui/react";

import {useChoseOnFlag} from "../../../../utils/Selecting";

type Props = {
    buttonName?: string;
    isActive?: boolean;
    isDisabled?: boolean;
};

export default function OptionBtn(props: Props) {
    const activeColor = useChoseOnFlag(props.isActive, "#CCB288", undefined);

    return (
        <Button
            color={activeColor}
            borderColor=" 2px solid #CCB288"
            fontSize={{base: "0.5rem", mobile8: "1rem", tablet16: "2rem"}}
            bg="transparent"
            p="0rem"
            h="full"
            _hover={{
                bg: "transparent",
            }}
            _active={{
                bg: "transparent",
            }}
            _focus={{
                outline: "none",
                color: "#CCB288",
            }}
            isDisabled={props.isDisabled}
        >
            {props.isDisabled ? "SOLD OUT" : props.buttonName}
        </Button>
    );
}
